import { actions, selectors } from 'data'
import { ActionType, StateType } from 'data/types'
import { connect, ConnectedProps } from 'react-redux'
import { Dispatch } from 'redux'

import ChangePassword from './template'

export type PropsType = ConnectedProps<typeof connector>

const mapStateToProps = (state: StateType) => ({
  fieldLoading: selectors.changePassword.getFieldLoading(state)
})

const mapDispatchToProps = (dispatch: Dispatch<ActionType>) => ({
  onSubmit: () => {
    dispatch(actions.changePassword.submit())
  }
})

const connector = connect(mapStateToProps, mapDispatchToProps)

export default connector(ChangePassword)
